import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';

app.initializers.add('arturm/aibot', () => {
  // Add AI Bot badge and styling to bot's posts
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const post = this.attrs.post;
    const user = post.user();
    const botUserId = app.forum.attribute('arturm-aibot.bot_user_id');

    if (user && String(user.id()) === String(botUserId)) {
      items.add(
        'aibot-badge',
        <span className="AiBot-badge">
          <i className="fas fa-robot icon"></i>
          AI Bot
        </span>,
        90
      );
    }
  });

  // Add CSS class to bot posts for styling
  extend(CommentPost.prototype, 'elementAttrs', function () {
    const post = this.attrs.post;
    const user = post.user();
    const botUserId = app.forum.attribute('arturm-aibot.bot_user_id');

    if (user && String(user.id()) === String(botUserId)) {
      this.attrs.className = (this.attrs.className || '') + ' Post--aibot';
    }
  });
});
